import { useEffect } from 'react'

// Subscribes to the global "phoenix:refresh" event dispatched by the
// Phoenix page's pull-to-refresh handler. Hooks pass their refetch fn
// so the active tab refreshes when the user pulls down.
//
// The dispatcher attaches an `await` array on the event's detail. We
// push the refetch's promise onto it so the dispatcher can Promise.all
// across every listener and keep the spinner visible until every
// background refresh actually settles (rather than disappearing after
// a fixed timeout while requests are still in flight).
export function usePhoenixRefresh(refetch) {
  useEffect(() => {
    if (!refetch) return undefined
    const handler = (e) => {
      const result = refetch()
      const list = e?.detail?.await
      if (list && result && typeof result.then === 'function') {
        list.push(result)
      }
    }
    window.addEventListener('phoenix:refresh', handler)
    return () => window.removeEventListener('phoenix:refresh', handler)
  }, [refetch])
}
